/**
 * ADIRA Reviews - Frontend JavaScript
 * 
 * API: https://adira.coffee/reviews/api.php
 */

class AdiraReviews {
  constructor(options = {}) {
    this.apiBase = 'https://adira.coffee/reviews/api.php';
    this.apiKey = options.apiKey || 'adira2026reviews';
    this.productHandle = options.productHandle || '';
    this.productTitle = options.productTitle || '';
    this.container = options.container || '#adira-reviews';
    this.formContainer = options.formContainer || '#adira-review-form';
    
    this.reviews = [];
    this.stats = null;
    this.currentPage = 1;
    this.sortBy = 'newest';
    
    if (this.productHandle) {
      this.init();
    }
  }
  
  async init() {
    await this.loadReviews();
    this.render();
    this.bindEvents();
    this.updateProductHeader();
  }
  
  async loadReviews(page = 1) {
    try {
      const url = `${this.apiBase}?action=get&handle=${encodeURIComponent(this.productHandle)}&page=${page}&sort=${this.sortBy}`;
      const response = await fetch(url);
      const data = await response.json();
      
      if (data.success) {
        this.reviews = data.reviews;
        this.stats = data.stats;
        this.pagination = data.pagination;
        this.currentPage = page;
      }
    } catch (error) {
      console.error('Failed to load reviews:', error);
    }
  }
  
  render() {
    const container = document.querySelector(this.container);
    if (!container) return;
    
    container.innerHTML = this.renderHTML();
  }
  
  renderHTML() {
    const { stats, reviews } = this;
    
    if (!stats || stats.total === 0) {
      return `
        <div class="reviews-empty">
          <h3>No reviews yet</h3>
          <p>Be the first to review this product!</p>
          ${this.renderForm()}
        </div>
      `;
    }
    
    return `
      <div class="reviews-container">
        ${this.renderSummary()}
        ${this.renderForm()}
        ${this.renderSortFilter()}
        <div class="reviews-list">
          ${reviews.map(r => this.renderReview(r)).join('')}
        </div>
        ${this.renderPagination()}
      </div>
    `;
  }
  
  renderSummary() {
    const { stats } = this;
    const fullStars = Math.floor(stats.average);
    const hasHalf = stats.average % 1 >= 0.5;
    
    let starsHtml = '';
    for (let i = 1; i <= 5; i++) {
      if (i <= fullStars) {
        starsHtml += '<span class="star filled">★</span>';
      } else if (i === fullStars + 1 && hasHalf) {
        starsHtml += '<span class="star half">★</span>';
      } else {
        starsHtml += '<span class="star empty">☆</span>';
      }
    }
    
    return `
      <div class="reviews-summary">
        <div class="summary-score">
          <span class="score-number">${stats.average.toFixed(1)}</span>
          <div class="score-stars">${starsHtml}</div>
          <span class="score-count">${stats.total} review${stats.total !== 1 ? 's' : ''}</span>
        </div>
        <div class="summary-bars">
          ${[5,4,3,2,1].map(n => {
            const count = stats.distribution[n] || 0;
            const percent = stats.total > 0 ? (count / stats.total * 100) : 0;
            return `
              <div class="rating-bar">
                <span class="bar-label">${n}★</span>
                <div class="bar-track">
                  <div class="bar-fill" style="width: ${percent}%"></div>
                </div>
                <span class="bar-count">${count}</span>
              </div>
            `;
          }).join('')}
        </div>
      </div>
    `;
  }
  
  renderForm() {
    return `
      <div class="review-form-wrapper">
        <button class="btn-write-review" onclick="adiraReviews.toggleForm()">
          ✍️ Write a Review
        </button>
        <form class="review-form" id="reviewForm" style="display:none;" onsubmit="adiraReviews.submitReview(event)">
          <h3>Write Your Review</h3>
          
          <div class="form-group">
            <label>Rating *</label>
            <div class="star-rating" id="starRating">
              ${[1,2,3,4,5].map(n => `<span class="star" data-rating="${n}">☆</span>`).join('')}
            </div>
            <input type="hidden" name="rating" id="ratingInput" required>
          </div>
          
          <div class="form-group">
            <label for="reviewTitle">Review Title *</label>
            <input type="text" id="reviewTitle" name="title" required maxlength="200" placeholder="Summarize your experience">
          </div>
          
          <div class="form-group">
            <label for="reviewBody">Your Review *</label>
            <textarea id="reviewBody" name="body" required maxlength="2000" rows="4" placeholder="What did you like or dislike?"></textarea>
          </div>
          
          <div class="form-row">
            <div class="form-group">
              <label for="reviewAuthor">Your Name *</label>
              <input type="text" id="reviewAuthor" name="author" required maxlength="100">
            </div>
            <div class="form-group">
              <label for="reviewEmail">Email *</label>
              <input type="email" id="reviewEmail" name="email" required>
            </div>
          </div>
          
          <div class="form-group checkbox">
            <label>
              <input type="checkbox" name="recommend" checked>
              I recommend this product
            </label>
          </div>
          
          <button type="submit" class="btn-submit">Submit Review</button>
          <p class="form-note">Your review will be published after approval.</p>
        </form>
      </div>
    `;
  }
  
  renderSortFilter() {
    const totalText = this.stats?.total ? `Showing ${this.reviews.length} of ${this.stats.total} reviews` : '';
    return `
      <div class="reviews-toolbar">
        <span class="reviews-count">${totalText}</span>
        <div class="reviews-sort">
          <label>Sort by:</label>
          <select onchange="adiraReviews.changeSort(this.value)">
            <option value="newest" ${this.sortBy === 'newest' ? 'selected' : ''}>Newest</option>
            <option value="oldest" ${this.sortBy === 'oldest' ? 'selected' : ''}>Oldest</option>
            <option value="highest" ${this.sortBy === 'highest' ? 'selected' : ''}>Highest Rated</option>
            <option value="lowest" ${this.sortBy === 'lowest' ? 'selected' : ''}>Lowest Rated</option>
            <option value="helpful" ${this.sortBy === 'helpful' ? 'selected' : ''}>Most Helpful</option>
          </select>
        </div>
      </div>
    `;
  }
  
  renderReview(review) {
    const date = new Date(review.created_at).toLocaleDateString('en-US', {
      year: 'numeric', month: 'short', day: 'numeric'
    });
    
    const stars = '★'.repeat(review.rating) + '☆'.repeat(5 - review.rating);
    
    return `
      <div class="review-item">
        <div class="review-header">
          <span class="review-stars">${stars}</span>
          <span class="review-date">${date}</span>
        </div>
        <h4 class="review-title">${this.escapeHtml(review.title)}</h4>
        <p class="review-body">${this.escapeHtml(review.body)}</p>
        <div class="review-footer">
          <span class="review-author">${this.escapeHtml(review.author)}</span>
          ${review.recommend ? '<span class="review-recommend">✓ Recommends this product</span>' : ''}
        </div>
        <div class="review-helpful">
          <button onclick="adiraReviews.markHelpful(${review.id})" class="btn-helpful">
            👍 Helpful (${review.helpful_count || 0})
          </button>
        </div>
      </div>
    `;
  }
  
  renderPagination() {
    if (!this.pagination || this.pagination.pages <= 1) return '';
    
    const { page, pages, total } = this.pagination;
    let html = '<div class="reviews-pagination">';
    
    // Previous button
    html += `<button onclick="adiraReviews.goToPage(${page - 1})" ${page <= 1 ? 'disabled' : ''}>‹ Prev</button>`;
    
    // Page numbers
    const maxVisible = 5;
    let startPage = Math.max(1, page - Math.floor(maxVisible / 2));
    let endPage = Math.min(pages, startPage + maxVisible - 1);
    
    if (endPage - startPage < maxVisible - 1) {
      startPage = Math.max(1, endPage - maxVisible + 1);
    }
    
    if (startPage > 1) {
      html += `<button onclick="adiraReviews.goToPage(1)">1</button>`;
      if (startPage > 2) {
        html += `<span class="page-info">...</span>`;
      }
    }
    
    for (let i = startPage; i <= endPage; i++) {
      html += `<button onclick="adiraReviews.goToPage(${i})" class="${i === page ? 'active' : ''}">${i}</button>`;
    }
    
    if (endPage < pages) {
      if (endPage < pages - 1) {
        html += `<span class="page-info">...</span>`;
      }
      html += `<button onclick="adiraReviews.goToPage(${pages})">${pages}</button>`;
    }
    
    // Next button
    html += `<button onclick="adiraReviews.goToPage(${page + 1})" ${page >= pages ? 'disabled' : ''}>Next ›</button>`;
    
    html += '</div>';
    return html;
  }
  
  bindEvents() {
    // Star rating interaction
    document.addEventListener('click', (e) => {
      if (e.target.closest('#starRating .star')) {
        const star = e.target.closest('.star');
        const rating = parseInt(star.dataset.rating);
        this.setRating(rating);
      }
    });
  }
  
  setRating(rating) {
    document.getElementById('ratingInput').value = rating;
    const stars = document.querySelectorAll('#starRating .star');
    stars.forEach((star, index) => {
      star.textContent = index < rating ? '★' : '☆';
      star.classList.toggle('selected', index < rating);
    });
  }
  
  toggleForm() {
    const form = document.getElementById('reviewForm');
    form.style.display = form.style.display === 'none' ? 'block' : 'none';
  }
  
  async submitReview(event) {
    event.preventDefault();
    
    const form = event.target;
    const submitBtn = form.querySelector('.btn-submit');
    submitBtn.disabled = true;
    submitBtn.textContent = 'Submitting...';
    
    const data = {
      product_handle: this.productHandle,
      product_title: this.productTitle,
      author: form.author.value.trim(),
      email: form.email.value.trim(),
      rating: parseInt(form.rating.value),
      title: form.title.value.trim(),
      body: form.body.value.trim(),
      recommend: form.recommend.checked
    };
    
    try {
      const response = await fetch(`${this.apiBase}?action=submit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Reviews-Key': this.apiKey
        },
        body: JSON.stringify(data)
      });
      
      const result = await response.json();
      
      if (result.success) {
        form.reset();
        form.style.display = 'none';
        this.showMessage('Thank you! Your review has been submitted and will appear after approval.', 'success');
      } else {
        this.showMessage(result.error || 'Failed to submit review', 'error');
      }
    } catch (error) {
      this.showMessage('Network error. Please try again.', 'error');
    }
    
    submitBtn.disabled = false;
    submitBtn.textContent = 'Submit Review';
  }
  
  async changeSort(sortBy) {
    this.sortBy = sortBy;
    await this.loadReviews(1);
    this.render();
    this.bindEvents();
  }
  
  async goToPage(page) {
    await this.loadReviews(page);
    this.render();
    this.bindEvents();
    document.querySelector(this.container)?.scrollIntoView({ behavior: 'smooth' });
  }
  
  async markHelpful(reviewId) {
    try {
      await fetch(`${this.apiBase}?action=helpful&id=${reviewId}`);
      // Reload to show updated count
      await this.loadReviews(this.currentPage);
      this.render();
      this.bindEvents();
    } catch (error) {
      console.error('Failed to mark helpful:', error);
    }
  }
  
  showMessage(text, type = 'info') {
    const existing = document.querySelector('.review-message');
    if (existing) existing.remove();
    
    const msg = document.createElement('div');
    msg.className = `review-message ${type}`;
    msg.textContent = text;
    
    const container = document.querySelector(this.container);
    container?.insertBefore(msg, container.firstChild);
    
    setTimeout(() => msg.remove(), 5000);
  }
  
  escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }
  
  // Update the product header with rating stats
  updateProductHeader() {
    if (!this.stats) return;
    
    const starsContainer = document.getElementById('product-stars');
    const countElement = document.getElementById('product-review-count');
    
    if (starsContainer) {
      const fullStars = Math.floor(this.stats.average);
      const hasHalf = this.stats.average % 1 >= 0.5;
      
      let starsHtml = '';
      for (let i = 1; i <= 5; i++) {
        const filled = i <= fullStars || (i === fullStars + 1 && hasHalf);
        const color = filled ? '#f5a623' : '#ddd';
        starsHtml += `<svg class="star ${filled ? 'star--filled' : 'star--empty'}" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" style="color: ${color};"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>`;
      }
      starsContainer.innerHTML = starsHtml;
    }
    
    if (countElement) {
      if (this.stats.total === 0) {
        countElement.textContent = 'No reviews yet';
      } else {
        countElement.textContent = `${this.stats.total} review${this.stats.total !== 1 ? 's' : ''}`;
      }
    }

    // Update incentive rating badge
    const incentiveBadge = document.getElementById('incentive-rating-badge');
    const incentiveValue = document.getElementById('incentive-rating-value');
    if (incentiveBadge && incentiveValue && this.stats.total > 0) {
      incentiveValue.textContent = this.stats.average.toFixed(1);
      incentiveBadge.style.display = '';
    }

    // Update mobile hook overlay
    const mobileHookCount = document.getElementById('mobile-hook-count');
    const mobileHookStars = document.getElementById('mobile-hook-stars');
    if (mobileHookCount && this.stats.total > 0) {
      mobileHookCount.textContent = `(${this.stats.total})`;
    }
    if (mobileHookStars && this.stats.total > 0) {
      const mhStarSvgs = mobileHookStars.querySelectorAll('svg');
      const fullStarsMh = Math.floor(this.stats.average);
      const hasHalfMh = this.stats.average % 1 >= 0.5;
      mhStarSvgs.forEach(function(svg, i) {
        const filled = (i + 1) <= fullStarsMh || ((i + 1) === fullStarsMh + 1 && hasHalfMh);
        svg.setAttribute('fill', filled ? '#C4583B' : '#666');
      });
    }
  }
}

// Auto-initialize if data attributes present
document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('[data-reviews-product]');
  if (container) {
    window.adiraReviews = new AdiraReviews({
      productHandle: container.dataset.reviewsProduct,
      productTitle: container.dataset.reviewsTitle || '',
      container: '[data-reviews-product]'
    });
  }
  
  // Also load stats for product header even without reviews section
  const ratingContainer = document.querySelector('.adira-product__rating[data-product-handle]');
  if (ratingContainer && !container) {
    const handle = ratingContainer.dataset.productHandle;
    if (handle) {
      fetch(`https://adira.coffee/reviews/api.php?action=stats&handle=${encodeURIComponent(handle)}`)
        .then(res => res.json())
        .then(data => {
          if (data.success && data.stats) {
            const stats = data.stats;
            const starsContainer = document.getElementById('product-stars');
            const countElement = document.getElementById('product-review-count');
            
            if (starsContainer) {
              const fullStars = Math.floor(stats.average);
              const hasHalf = stats.average % 1 >= 0.5;
              let starsHtml = '';
              for (let i = 1; i <= 5; i++) {
                const filled = i <= fullStars || (i === fullStars + 1 && hasHalf);
                const color = filled ? '#f5a623' : '#ddd';
                starsHtml += `<svg class="star ${filled ? 'star--filled' : 'star--empty'}" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" style="color: ${color};"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>`;
              }
              starsContainer.innerHTML = starsHtml;
            }
            
            if (countElement) {
              countElement.textContent = stats.total === 0 ? 'No reviews yet' : `${stats.total} review${stats.total !== 1 ? 's' : ''}`;
            }

            // Update incentive rating badge
            const incentiveBadge = document.getElementById('incentive-rating-badge');
            const incentiveValue = document.getElementById('incentive-rating-value');
            if (incentiveBadge && incentiveValue && stats.total > 0) {
              incentiveValue.textContent = stats.average.toFixed(1);
              incentiveBadge.style.display = '';
            }

            // Update mobile hook overlay
            const mobileHookCount = document.getElementById('mobile-hook-count');
            const mobileHookStars = document.getElementById('mobile-hook-stars');
            if (mobileHookCount && stats.total > 0) {
              mobileHookCount.textContent = `(${stats.total})`;
            }
            if (mobileHookStars && stats.total > 0) {
              const mhStarSvgs = mobileHookStars.querySelectorAll('svg');
              const fullStarsMh = Math.floor(stats.average);
              const hasHalfMh = stats.average % 1 >= 0.5;
              mhStarSvgs.forEach(function(svg, i) {
                const filled = (i + 1) <= fullStarsMh || ((i + 1) === fullStarsMh + 1 && hasHalfMh);
                svg.setAttribute('fill', filled ? '#C4583B' : '#666');
              });
            }
          }
        })
        .catch(err => console.error('Failed to load review stats:', err));
    }
  }
});